import { Component, Input, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReviewWrapperComponent } from '../../../ui/review-wrapper/review-wrapper.component';
import { SavedMessages } from '../../../../services/campaign/messages.service';
import { ScheduleService } from '../../../../services/campaign/schedule.service';
import { SmsBubbleComponent } from '../../../messages/sms-bubble/sms-bubble.component';
import { WizardAudienceService } from '../../../../pages/organization/campaigns/create-campaign/wizard-audience.service';
import { formatCount, smsParts } from '../../../../../utils/sms';

@Component({
  selector: 'app-message-review',
  standalone: true,
  imports: [ReviewWrapperComponent, SmsBubbleComponent],
  templateUrl: './message-review.component.html',
  styleUrl: '../campaign-review.css',
})
export class MessageReviewComponent {
  @Input() messages: SavedMessages[] = [];
  private scheduleService = inject(ScheduleService);
  private audience = inject(WizardAudienceService);

  constructor(private router: Router, private route: ActivatedRoute) {}

  /** "From SCHOOL · 2 sends · ≈ 2,408 SMS each". */
  metaFor(message: SavedMessages): string {
    const sends = this.scheduleService.messageSchedule
      .filter((schedule) => schedule.message?.id === message.id)
      .reduce((sum, schedule) => sum + (schedule.messageDates?.length ?? 0), 0);
    const { parts, estimated } = smsParts(message.body);
    const facts = [`From ${message.senderId || 'no sender ID'}`, sends === 1 ? '1 send' : `${sends} sends`];
    if (this.audience.count !== null && parts) {
      facts.push(`${estimated ? 'about ' : ''}${formatCount(parts * this.audience.count)} SMS each`);
    }
    return facts.join(' · ');
  }

  navigateToUrl() {
    this.router.navigate([], {
      relativeTo: this.route, // Stay on the current route
      queryParams: { step: 'messages' }, // Add the new query param
    });
  }
}
